import React from 'react';

interface SupportButtonTypeLinksProps {
    element: any
}

const SupportButtonTypeLinks: React.FC<SupportButtonTypeLinksProps> = (element) => {

    const handleLinks = (links: any) => {
        if(links){
            return Array.isArray(links) && links.map((item, index) => (
                <a href={window.location.origin + "/support/" + item?.attributes?.slug} className={index == 0 ? "d-block mx-auto bordered-btn button-type-links font-medium" : "d-block mt-4 mx-auto bordered-btn button-type-links font-medium"} key={index}>{item?.attributes?.Name}</a>
            ))
        }
    }

    return (
      <>
        <div className="container-fluid spacer-top">{handleLinks(element?.element?.Links?.data)}</div>
      </>
    );
};

export default SupportButtonTypeLinks;